export default {"src":"/pro/_next/static/media/xaut.31b25ca7.svg","height":400,"width":560,"blurWidth":0,"blurHeight":0};